import './App.css';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { routes } from './routes';
import Navbar from './components/Navbar/Navbar';
import toast, { Toaster } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import { useContext, useEffect, useState } from 'react';
import Login from './views/Login/Login';
import { saveToLocalSession, getFromLocalSession, removeFromLocalSession } from './utils/LocalStorage';
import { InterceptorFactory } from './utils/Interceptors';
import { genericGet } from './services/api.service';
import { userInfoHandler } from './utils/UserInfoHandler';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { PicaPontoContext } from './contexts/PicaPontoContext';

const interceptorFactory = new InterceptorFactory();

const requestHeaderProcessor = (request: any) => {
  request.headers['Authorization'] = `Bearer ${getFromLocalSession('bearer')}`;
}

const queryClient = new QueryClient();

function App() {

  const [user, setUser] = useState(getFromLocalSession('bearer'));
  const [userInfo, setUserInfo] = useState(null);
  const [loadingUserInfo, setLoadingUserInfo] = useState(null);
  const [userInfoReady, setUserInfoReady] = useState(false);
  const [modoPicaPonto, setModoPicaPonto] = useState(false);

  useEffect(() => {
    console.log("CHecking user: ", getFromLocalSession('bearer'));
    interceptorFactory.createRequestInterceptor(requestHeaderProcessor);
    interceptorFactory.createResponseInterceptor((error: any) => {

      console.log("Error: ", error);

      if (error.response?.status == 401) { // TODO specific error code?
        toast.error(() => (
          <span>
            <span>Sessão expirou, por favor autentique-se novamente</span>
          </span>
        ))

        setUser(null)
        setUserInfo(null);
      } else {
        console.log("Error? ", error);
        console.log("User authorized")

      }
    });
  }, [])


  useEffect(() => {
    if (user) {
      saveToLocalSession('bearer', user);
      if (user) {
        genericGet('/utilizadores/profile')
          .then(r => setUserInfo(r));
      }
    } else {
      console.log("Removing from local session");
      removeFromLocalSession('bearer');
    }
  }, [user])


  useEffect(() => {
    userInfoHandler.setUserInfo(userInfo);
    userInfo ? setUserInfoReady(true) : setUserInfoReady(false);
  }, [userInfo])


  return (
    <QueryClientProvider client={queryClient}>
      <PicaPontoContext.Provider value={{ modoPicaPonto, setModoPicaPonto }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Toaster
            position="top-right"
          />
          <div className="flex w-full max-h-full overflow-y-hidden">
            <Router>
              
                {userInfoReady ? <Navbar user={user} userInfo={userInfo} setUser={setUser} setUserInfo={setUserInfo} routes={routes}></Navbar> : null}
              
              {(user && userInfo && userInfoReady) ? <div className="routesClass">

                <Routes>
                  {routes.map((prop: any, key: any) => {
                    return (
                      <Route
                        path={prop.path}
                        element={prop.component}
                        key={key}
                      />
                    );
                  })}
                </Routes></div> : null}
              {(!user && !loadingUserInfo) ? <Login setUser={setUser} /> : null}
            </Router>
          </div>
        </LocalizationProvider>
      </PicaPontoContext.Provider>
    </QueryClientProvider>
  );
}

export default App;
